import { registerWidget } from '../../common/core';
import { FuseTreeFacetWidgetDefinition } from './fuse-treefacet';

registerWidget('fuse-treefacet', FuseTreeFacetWidgetDefinition);